import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'
import { deleteSiteDispatchCurtailmentPlan, getSiteDispatches } from '@/services/eos/dispatches'
import type { ISiteDispatchFilters } from '@/types/eos/filters'
import { NotifyFail, NotifySuccess } from '@/helpers/core/notifications'

export const useSiteDispatches = () => {
  const queryClient = useQueryClient()

  const getSiteDispatchesQuery = (filters: ISiteDispatchFilters) =>
    useQuery({
      queryKey: ['site-dispatches', filters],
      queryFn: () => getSiteDispatches(filters),
    })

  const deleteSiteDispatchCurtailmentPlanMutation = useMutation({
    mutationFn: ({ siteDispatchID, curtailmentPlanID }: { siteDispatchID: number; curtailmentPlanID: number }) =>
      deleteSiteDispatchCurtailmentPlan(siteDispatchID, curtailmentPlanID),
    onSuccess: () => {
      NotifySuccess('Curtailment plan deleted successfully')
      queryClient.invalidateQueries({ queryKey: ['site-dispatches'] })
    },
    onError: (error: any) => {
      NotifyFail(error.message)
    },
  })

  return {
    getSiteDispatchesQuery,
    deleteSiteDispatchCurtailmentPlanMutation,
  }
}
